import { render, staticRenderFns } from "./IntroPage.vue?vue&type=template&id=2eb1bbeb&scoped=true&"
import script from "./IntroPage.vue?vue&type=script&lang=js&"
export * from "./IntroPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroPage.vue?vue&type=style&index=0&id=2eb1bbeb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb1bbeb",
  null
  
)

export default component.exports